/**
 * Host-neutral client-side lifecycle hooks for FactSet session state.
 *
 * The OAuth service owns the server grant and dialog flow, but feature
 * modules can keep per-session client state derived from that grant. A
 * successful disconnect must clear that state without forcing the OAuth
 * service to import feature-specific modules such as Excel TTF caching.
 */

type FactSetClientSessionClearHandler = () => void;

const clearHandlers = new Set<FactSetClientSessionClearHandler>();

export function registerFactSetClientSessionClearHandler(
  handler: FactSetClientSessionClearHandler,
): () => void {
  clearHandlers.add(handler);
  return () => {
    clearHandlers.delete(handler);
  };
}

export function clearFactSetClientSessionState(): void {
  for (const handler of clearHandlers) {
    try {
      handler();
    } catch (error) {
      console.warn(
        "[FactSetSession] Failed to clear client session state",
        error instanceof Error ? error.message : String(error),
      );
    }
  }
}
